import { accountingJournalTypeOptions } from './../../../../../../../types/src/mado/enum/journal-type.enum';
import { Component, computed, inject, ViewChild } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { OrganizationSettingsJournalStore } from './organization-settings-journal.store';
import { journalFrag } from './organization-settings-journal.query';
import { AccountingJournalObject } from '@libs/types/src/mado/object-type/journal.object';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';
import { FilterInput } from '@it2go/data-grid';
import { ConfirmBuilder } from 'packages/client/src/app/modules/shared/service/confirm.builder';
import { OrganizationSettingsJournalDialogComponent } from './dialog/organization-settings-journal-dialog.component';
import { madoAccountToDropdownOptionString } from 'packages/client/src/app/utils/mado/account.utils';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { CheckOrCrossComponent } from '../../../kit/check-or-cross/check-or-cross.component';


@Component({
    selector: 'app-organization-settings-journal',
    templateUrl: './organization-settings-journal.component.html',
    providers: [OrganizationSettingsJournalStore],
    imports: [PrimeTemplate, CheckOrCrossComponent, TableComponent],
})
export class OrganizationSettingsJournalComponent {
    protected readonly store = inject(OrganizationSettingsJournalStore);
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly confirm = inject(ConfirmBuilder);

    protected readonly prefix = 'madoJournal.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
            filterable: true,
        },
        {
            name: 'code',
            filterable: true,
        },
        {
            name: 'type',
            data: (item: any) => translate.instant(this.prefix + 'journalTypeOptions.' + item),
            filterable: {
                type: 'select',
                selectOptions: () => accountingJournalTypeOptions,
            },
        },
        {
            name: 'accountId',
        },
        {
            name: 'currencyId',
        },
        {
            name: 'isDefault',
        },
    ];

    protected readonly filters = computed<FilterInput[][]>(() => [
        [{ column: 'organizationId', operator: 'EQ', value: [routeParams.organizationId()] }],
    ]);

    @ViewChild('journalTable') private tableRef!: TableComponent;

    openDialog(journal: AccountingJournalObject | null = null) {
        const header = `${this.prefix}` + (journal ? 'update' : 'create');
        const dialog = this.dialogService.open(
            OrganizationSettingsJournalDialogComponent,
            {
                header: translate.instant(header),
                data: { journal, organizationId: routeParams.organizationId() },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.tableRef?.reload();
            }
        });
    }

    deleteItem(event: any) {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteAccountingJournal({ id: event.item.id });
                this.tableRef.reload();
            },
            event,
        );
    }

    protected readonly journalFrag = journalFrag;
    protected readonly madoAccountToDropdownOptionString = madoAccountToDropdownOptionString;
}
